import { isDefined } from '@sgme/fp';
import { BlockMetadataContext } from 'components/common-form/contexts/BlockMetadataContext';
import type { BlockMetadata } from 'models/metadata/block.definition';
import { useContext } from 'react';

export function useBlockMetadata(blockId: string): Readonly<BlockMetadata> | undefined {
  const metadataById = useContext(BlockMetadataContext);
  return metadataById[blockId];
}

export function useBlocksMetadata(blockIds: string[]): BlockMetadata[] {
  const metadataById = useContext(BlockMetadataContext);
  return blockIds.map(id => metadataById[id]).filter(isDefined);
}
